import React, { useState, useEffect } from "react";
import { BASE_URL } from "../../../constants";
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
//import {Row, Col, Container, Card} from 'react-bootstrap';
import { Row, Col, Container, Card, Button, Tooltip, OverlayTrigger, InputGroup } from 'react-bootstrap';
import '../../../CommonCSS/SocietyCSS.css';
import EditFeesStructModal from './EditFeesStructModal';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from 'react-select';

const ClassFeeStructure = () => {
//  const [isEditable, setIsEditable] = useState(false);
  const [ddlFeeDescs, setDdlFeeDescs] = useState([]);
  const [ddlAllStandards, setDdlAllStandards] = useState([]);
  const [ddlDivisions, setDdlDivisions] = useState([]);
  const [ddlAcademicYears, setDdlAcademicYears] = useState([]);

  const [errors, setErrors] = useState({});

  // Header State
  const [headerData, setHeaderData] = useState({
    fs_id: '',
    year1: '',
    year2: '',
    std_id: '',
    div_id: '',
  });

    // Child Table Data
  const [childRows, setChildRows] = useState([
    {
      fs_id: '',
      fee_code: '',
      fee_desc: '',
      fee_type: 'M',
      install_no: '0',
      fee_amt: '',
      original_fee_code: '',
      isDeleted: false
    }
  ]);

  const [deletedRows, setDeletedRows] = useState([]);

  const PAGE_MODE = {
    INITIAL: "INITIAL",
    NEW: "NEW",
    PROCEED: "PROCEED",
    EDIT: "EDIT",
  };

  const [pageMode, setPageMode] = useState(PAGE_MODE.INITIAL);

  const isHeaderEnabled = pageMode === PAGE_MODE.NEW;
  const isProceedEnabled = pageMode === PAGE_MODE.NEW;
  const isChildEnabled = pageMode === PAGE_MODE.PROCEED || pageMode === PAGE_MODE.EDIT;
  const isSaveEnabled = pageMode === PAGE_MODE.PROCEED || pageMode === PAGE_MODE.EDIT;
  const isClearEnabled = pageMode !== PAGE_MODE.INITIAL;
  const isNewEnabled = pageMode === PAGE_MODE.INITIAL;
  const isEditEnabled = pageMode === PAGE_MODE.INITIAL;

  const [rowErrors, setRowErrors] = useState({});
  const [showsearchModal, setShowSearchModal] = useState(false);

  const handleChildChange = (index, e) => {

    const { name, value } = e.target;
    const updatedRows = [...childRows];

    if (name === 'fee_amt') {
      const sanitizedValue = value
        .replace(/[^\d.]/g, "")       // remove non-numeric chars
        .replace(/(\..*)\./g, "$1");
      updatedRows[index][name] = sanitizedValue;
    } else {
      updatedRows[index][name] = value;
    }

    setChildRows(updatedRows);

    setRowErrors({});

  };

  useEffect(() => {

    fetchLists();

  }, []);

  const fetchLists = async () => {
    try {

      const feeDescResult = await axios.get(`${BASE_URL}/api/ddl_fees_desc`);
      setDdlFeeDescs(feeDescResult.data);

      const stdResult = await axios.get(`${BASE_URL}/api/ddl_all_standards`);
      setDdlAllStandards(stdResult.data);

      const year_result = await axios.get(`${BASE_URL}/api/ddl_years`);
      setDdlAcademicYears(year_result.data);

    } catch (err) {
      console.error("Dropdown fetch error:", err);
    }
  };

  /// To Populate Division on change of Standard
  useEffect(() => {

    const fetchDivision = async () => {
      try {
        setDdlDivisions([]);
        if (headerData.std_id) {
          const res = await axios.get(`${BASE_URL}/api/ddl_division`, { params: { p_Std_Id: headerData.std_id } });
          setDdlDivisions(res.data || []);
        }
      } catch (error) {
        console.error("Error fetching Division:", error);
      }
    };

    fetchDivision();

  }, [headerData.std_id]);

  const addRow = () => {

    //const newIndex = childRows.length + 1; // 1-based index

  //  setChildRows([...childRows, newRow]);
    setChildRows([...childRows, { fs_id: '', fee_code: '', fee_desc: '', fee_type: 'M', original_fee_code: '',
                          install_no: '0', fee_amt: '', isDeleted: false }]);
  
  };

  const removeRow = (index) => {

    const row = childRows[index];

    // Existing DB row
    if (row.fs_id) {
      const updatedRows = [...childRows];
      updatedRows[index] = { ...updatedRows[index], isDeleted: true };
      setChildRows(updatedRows);
    }
    else {
      // Unsaved row
      setChildRows(prev => prev.filter((_, i) => i !== index)
      );
    }

    setRowErrors({});

  };

  const undoDelete = (index) => {

    const updatedRows = [...childRows];

    updatedRows[index] = {
      ...updatedRows[index],
      isDeleted: false
    };

    setChildRows(updatedRows);
  };

  const handleNew = () => {

    //setIsEditable(true);
    resetPage();
    setPageMode(PAGE_MODE.NEW);

  };

  const handleProceed = async () => {

    const newErrors = {};

    if (!headerData.std_id || headerData.std_id === '') {
      newErrors.std_id = 'Error';
      toast.error('Please select Standard.');
    } else if (!headerData.div_id || headerData.div_id === '') {
      newErrors.div_id = 'Error';
      toast.error('Please select Division.');
    } else if (!headerData.year1 || headerData.year1 === '') {
      newErrors.year1 = 'Error';
      toast.error('Please select Academic Year.');
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      const firstErrorKey = Object.keys(newErrors)[0];
      if (firstErrorKey) {
        const el = document.getElementsByName(firstErrorKey)[0];
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
          el.focus(); // 🔥 bonus (cursor goes there)
        }
      }
      return;
    }

    const response = await axios.get(`${BASE_URL}/api/validate_fees_struct`,
      { params: { p_Std_Id: headerData.std_id, p_Div_Id: headerData.div_id, p_Year1: headerData.year1 } });

    if (response.data[0].rows_count !== '0') {
      toast.error('Fees Structure already exists for the selected Standard, Division and Academic Year.');
      return;
    }

    setPageMode(PAGE_MODE.PROCEED);

  };

  const handleHeaderChange = (e) => {

    const { name, value } = e.target;
    setHeaderData(prev => ({ ...prev, [name]: value }));

    if (name === 'year1') {
       setHeaderData(prev => ({ ...prev, year2: Number(value) + 1 }));
    }

    setErrors(prev => ({
      ...prev,
      [name]: ""
    }));

  };

  const resetPage = async () => {

    setHeaderData({ fs_id: '', std_id: '', div_id: '', year1: '', year2: '', });
    setChildRows([{ fs_id: '', fee_code: '', fee_desc: '', fee_type: 'M', install_no: '0', 
                     fee_amt: '', original_fee_code: '', isDeleted: false }]);

    setDeletedRows([]);

    setPageMode(PAGE_MODE.INITIAL);

  }

  const handleSave = async () => {

    const errors = {};

    // =========================
    // Row Validation
    // =========================

    for (let i = 0; i < childRows.length; i++) {

      const row = childRows[i];

      if (row.isDeleted) continue;

      // Fee Code Validation
      if (!row.fee_code || row.fee_code === '') {
        errors[i] = { field: 'fee_code' };
        setRowErrors(errors);
        document.getElementById(`fee_code_${i}`)?.focus();
        toast.error(`Please select Fee Code at Row # ${i + 1}`);
        return;
      }

      // Fee Amount Validation
      const amount = parseFloat(
        String(row.fee_amt || "0").replace(/,/g, "")
      );

      if (!row.fee_amt || isNaN(amount) || amount <= 0) {
        errors[i] = { field: 'fee_amt' };
        setRowErrors(errors);
        document.getElementById(`fee_amt_${i}`)?.focus();
        toast.error(`Please enter valid Fee Amount at Row # ${i + 1}`);
        return;
      }
    }


    // =========================
    // Duplicate Validation
    // =========================

    const feeCodeSet = new Set();

    for (let i = 0; i < childRows.length; i++) {

      const row = childRows[i];

      if (row.isDeleted) continue;

      const feeCode = childRows[i].fee_code;

      if (feeCodeSet.has(feeCode)) {

        errors[i] = {
          field: 'fee_code'
        };

        setRowErrors(errors);

        document.getElementById(`fee_code_${i}`)?.focus();

        toast.error(`Duplicate Fee Code at Row # ${i + 1}`);

        return;
      }

      feeCodeSet.add(feeCode);
    }

    // clear errors if validation passed
    setRowErrors({});

    const isConfirmed = window.confirm("Sure you want to Save the record ?");

    if (!isConfirmed) return;

    const detailRows = childRows.filter(row => !row.isDeleted);

    const deletedRows = childRows.filter(row => row.isDeleted && row.fs_id);

    const feesStructData = {
      header: headerData,
      details: detailRows,
      deletedDetails: deletedRows,
    };

    const response = await axios.post(`${BASE_URL}/api/save_fees_structure`, feesStructData);

    if (response.data.message === '1') {
      toast.success('Fees Structure saved successfully.')
      //setIsEditable(false);
      resetPage();
    }

  };

  const handleClear = () => {
    if (window.confirm("Clear all data?")) {
      resetPage();
      //setIsEditable(false);
    }
  };

  const handleDtlAmtBlur = (index, e) => {

    const { name, value } = e.target;

    if (!value) return;

    let numericValue = parseFloat(value.replace(/,/g, ""));

    if (isNaN(numericValue)) return;

    // truncate to 2 decimals
    numericValue = Math.trunc(numericValue * 100) / 100;

    const formatted = new Intl.NumberFormat("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(numericValue);

    const updated = [...childRows];
    updated[index][name] = formatted;

    setChildRows(updated);

  };

  const handleFeesCodeChange = (index, selectedOption) => {

    const updated = [...childRows];
    updated[index].fee_code = selectedOption ? selectedOption.value : "";
    updated[index].fee_desc = selectedOption ? selectedOption.label : "";
    setChildRows(updated);

    setRowErrors({});

  };

  // const handleFeesCodeChange = (index, selectedOption) => {

  //   const updated = [...childRows];
  //   const newFeeCode = selectedOption ? selectedOption.value : "";

  //   updated[index].fee_code = newFeeCode;
  //   updated[index].fee_desc = selectedOption ? selectedOption.label : "";

  //   // Only for existing rows
  //   if (updated[index].fs_id) {
  //     updated[index].feeCodeChanged = String(updated[index].original_fee_code) !== String(newFeeCode);
  //   }

  //   setChildRows(updated);
  //   setRowErrors({});

  // };

  const handleSelectedRow = async (selRow) => {

    setShowSearchModal(false);

    const response = await axios.get(`${BASE_URL}/api/get_Fees_Struct_ById`, { params: {p_FS_Id: selRow.fs_id}});

    headerData.fs_id = selRow.fs_id;
    headerData.std_id = response.data[0].std_id;
    headerData.div_id = response.data[0].div_id;
    headerData.year1 = response.data[0].year1;
    headerData.year2 = response.data[0].year2;

    const formattedRows = response.data.map(row => ({...row,
      original_fee_code: row.fee_code,
      fee_amt: new Intl.NumberFormat("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2,}).format(row.fee_amt),}));

    setChildRows(formattedRows);

    setPageMode(PAGE_MODE.EDIT);

   // setIsEditable(true);

  };

  const feesDescOptions = ddlFeeDescs.map(code => ({
    value: String(code.fee_code),
    label: code.fee_desc
  })) || [];

  const totalFeeAmount = childRows.reduce((total, row) => {

    // Ignore soft-deleted rows
    if (row.isDeleted) {
      return total;
    }

    // remove commas and convert to number
    const amount = parseFloat(
      String(row.fee_amt || "0").replace(/,/g, "")
    );

    if (isNaN(amount)) return total;

    let multiplier = 1;

    switch (row.fee_type) {
      case "M":
        if (headerData.std_id < 14) {
          multiplier = 12;
        } else {
          multiplier = 2;
        }
        
        break;

      case "Q":
        multiplier = 4;
        break;

      case "H":
        multiplier = 2;
        break;

      case "A":
      case "O":
      case "D":
      default:
        multiplier = 1;
        break;
    }

    return total + (amount * multiplier);

  }, 0);

  return (
    <Container fluid className="p-3">
      <Card className="mb-4 p-3">

        {<Row className="mb-3">

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "120px" }}>
                Standard<span style={{ color: "red" }}>*</span>
              </InputGroup.Text>
              <select className={`form-select ${errors.std_id ? "is-invalid" : ""}`}
                      name="std_id" value={headerData.std_id}
                      disabled={!isHeaderEnabled} onChange={handleHeaderChange} >
                <option value="">--Select Standard--</option>
                {ddlAllStandards.map(std => (
                  <option key={std.std_id} value={std.std_id}>{std.std_name}</option>
                ))}
              </select>
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "90px" }}>Division<span style={{ color: "red" }}>*</span>
              </InputGroup.Text>
              <select className={`form-select ${errors.div_id ? "is-invalid" : ""}`}
                 name="div_id"
                value={headerData.div_id} disabled={!isHeaderEnabled} onChange={handleHeaderChange}>
                <option value="">-- Select Division --</option>
                <option value="0">All Divisions</option>
                {ddlDivisions.map(div => (
                  <option key={div.div_id} value={div.div_id}>{div.div_name}</option>
                ))}
              </select>
            </InputGroup>
          </Col>

          <Col md={4}>

            <InputGroup>
              <InputGroup.Text style={{ width: "140px" }}>Academic Year<span style={{ color: "red" }}>*</span></InputGroup.Text>
              <select className={`form-select ${errors.year1 ? "is-invalid" : ""}`}
                name="year1" value={headerData.year1}
                onChange={handleHeaderChange} disabled={!isHeaderEnabled} >
                <option value="">--Select Acadamic Year--</option>
                {ddlAcademicYears.map(y => (
                  <option key={y.year1} value={y.year1}>{y.disp_year}</option>
                ))}
              </select>

            </InputGroup>
          </Col>

          <Col md={2}>
            <button type="button" className="btn btn-warning" style={{ width: "200px" }} onClick={handleProceed}
              disabled={!isProceedEnabled} > Proceed Fee Structure 
            </button>
          </Col>
          
        </Row>}

        <div className="d-flex justify-content-end gap-2 mt-3 flex-wrap">

          <button type="button" className="btn btn-primary" style={{ width: "135px" }}
            onClick={handleNew} disabled={!isNewEnabled} > New
          </button>

          <button type="button" className="btn btn-warning" style={{ width: "135px" }}
            onClick={(e) => (setShowSearchModal(true))}
            disabled={!isEditEnabled}> Edit
          </button>
          {showsearchModal && (
            <EditFeesStructModal
              show={showsearchModal}
              handleClose={() => setShowSearchModal(false)}
              onRowSelect={handleSelectedRow} />
          )}

          <button type="button" className="btn btn-secondary" style={{ width: "135px" }}
            onClick={handleClear} disabled={!isClearEnabled}> Clear
          </button>

          <button type="button" className="btn btn-success" style={{ width: "135px" }}
            onClick={handleSave} disabled={!isSaveEnabled} > Save
          </button>
        </div>
      </Card>

      {/* Child Table */}
      <Card className="p-3">
        {/* <h5>Maintenance Items</h5> */}
        <div style={{ minHeight: '220px' }} className="table-wrapper">
          <table style={{ maxHeight: '35px' }} className="responsive-table scty-custom-table">
            <thead>
              <tr>
                <th style={{ width: '4%', textAlign: 'center' }}>#</th>
                <th style={{ width: '35%', textAlign: 'left' }}>Fees Description</th>
                <th style={{ width: '16%', textAlign: 'left' }}>Fees Type</th>
                <th style={{ width: '16%', textAlign: 'center' }}>Installment </th>
                <th style={{ width: '15%', textAlign: 'right' }}>Fees Amount</th>
                <th style={{ width: '6%', textAlign: 'right' }}></th>
              </tr>
            </thead>
            <tbody>
              {childRows.map((row, index) => (
                <tr key={index} 
                  style={{
                    textDecoration: row.isDeleted ? "line-through" : "none",
                    color: row.isDeleted ? "#999" : "inherit",
                    backgroundColor: row.isDeleted ? "#f8d7da" : ""
                  }}>
                  <td style={{ width: "5%", textAlign: 'center' }}>{index + 1}</td>
                  <td>
                    <Select name="fee_code"
                      inputId={`fee_code_${index}`} classNamePrefix="react-select"
                      className={rowErrors[index]?.field === 'fee_code' ? 'react-select-error' : ''}
                      options={feesDescOptions}
                      value={feesDescOptions.find(option => String(option.value) === String(row.fee_code)) || null}
                      onChange={(selectedOption) => handleFeesCodeChange(index, selectedOption)}
                      isDisabled={!isChildEnabled || row.isDeleted} 
                      placeholder="-- Select Fees Description --"
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} />
                  </td>
                  <td>
                    <select className="form-select" disabled={!isChildEnabled || row.isDeleted} 
                            name="fee_type" 
                            value={row.fee_type} onChange={(e) => handleChildChange(index, e)}>
                      <option value="M">Monthly </option>
                      <option value="Q">Quaterly </option>
                      <option value="H">Half Yearly </option>
                      <option value="A">Annually </option>
                      <option value="O">One Time </option>
                      <option value="D">Adhoc </option>
                    </select>
                  </td>
                  <td>
                    <select className="form-select" disabled={!isChildEnabled || row.isDeleted} 
                            name="install_no" 
                            value={row.install_no} onChange={(e) => handleChildChange(index, e)}>
                      <option value="0">All Installments</option>
                      <option value="1">1st Installment</option>
                      <option value="2">2nd Installment</option>
                      <option value="3">3rd Installment</option>
                      <option value="4">4th Installment</option>
                      <option value="5">5th Installment</option>
                      <option value="6">6th Installment</option>
                      <option value="12">1st/2nd Installments</option>
                      <option value="14">1st/4th Installments</option>
                    </select>
                  </td>
                  <td>
                    <input style={{ textAlign: 'right' }} disabled={!isChildEnabled || row.isDeleted}
                      type="text" 
                      className={`form-control ${rowErrors[index]?.field === 'fee_amt' ? 'is-invalid' : ''}`}
                       name="fee_amt" value={row.fee_amt}
                       onChange={(e) => handleChildChange(index, e)} 
                        onBlur={(e) => handleDtlAmtBlur(index, e)}/>
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    {childRows.length > 1 ? (
                     !row.isDeleted ? (
                      <Button variant="danger" size="sm" onClick={() => removeRow(index)} > Delete </Button>
                    ) : (
                      <Button variant="success" size="sm" onClick={() => undoDelete(index)} > Undo </Button>
                    )
                  ) : null }
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr style={{ backgroundColor: '#f1f1f1' }}>
                <td colSpan="4" style={{ textAlign: 'right', fontWeight: 'bold', fontSize: '16px' }}>
                  Total Annual Fees :
                </td>
                <td style={{ textAlign: 'right', fontWeight: 'bold', fontSize: '16px' }}>
                  <span style={{ paddingRight: '12px', display: 'inline-block' }}>
                    {new Intl.NumberFormat("en-IN", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }).format(totalFeeAmount)}
                  </span>
                </td>
                <td></td>
              </tr>
            </tfoot>
          </table>
        </div>

        <div className="d-flex justify-content-end mt-2">
          <OverlayTrigger placement="bottom"
            overlay={<Tooltip id="add-tooltip" style={{ backgroundColor: "#e9ecef" }}>Add Row</Tooltip>}>
            <Button variant="primary" onClick={addRow} 
              disabled={!isChildEnabled}
              style={{ width: "45px", height: "45px", borderRadius: "50%", padding: "0", fontSize: "30px" }}> +
            </Button>
          </OverlayTrigger>
        </div>

      </Card>

      {/* Buttons */}
    </Container>
  );
};

export default ClassFeeStructure;
